interface DocumentPictureInPictureApi {
    requestWindow(options: {width: number; height: number}): Promise<Window>;
}

export const documentPictureInPicture = (): DocumentPictureInPictureApi | undefined =>
    (window as Window & {documentPictureInPicture?: DocumentPictureInPictureApi}).documentPictureInPicture;

export const supportsDocumentPictureInPicture = (): boolean => !!documentPictureInPicture();
